import { useTranslation } from 'react-i18next'
import { LinearProgress, Paper, Typography } from '@mui/material'
import { SyncStatus } from '@/core/offline'

export function ProgressBar({ syncStatus }: { syncStatus: SyncStatus }) {
  const { t } = useTranslation()

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="body2" gutterBottom>
        {t('sync.syncProgress')}: {syncStatus.completedCount} / {syncStatus.totalCount}
      </Typography>
      <LinearProgress
        variant="determinate"
        value={syncStatus.totalCount > 0 ? (syncStatus.completedCount / syncStatus.totalCount) * 100 : 0}
        sx={{ height: 8, borderRadius: 4 }}
      />
    </Paper>
  )
}
